import React from "react";
import { topSectionData, footerSection, NavSection } from "./HeaderAndFooter";
import { Helmet } from "react-helmet";
import { Fade, Zoom, } from 'react-reveal';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const contentSection = (
  <>
    <div class='dispfbanner'>
      <div class='bannerarea'>
        <h4 data-aos='zoom-in-down'>PLAY OR LEARN</h4>
        <h1 data-aos='fade-up'>
          Badminton -  Best Infrastructure. Professional Coaching.
        </h1>
        <div class='btarea' data-aos='zoom-in'></div>
      </div>
    </div>
    <div class='aboutarea ' data-aos='zoom-in'>
      <div class='aboutbox '>
        <div class='boxes '>
          <svg viewBox='0 0 55.558 47.814'>
            <use href='#stadium'></use>
          </svg>
          <h5> Best in Class Infra</h5>
        </div>
        <div class='boxes '>
          <svg>
            <use href='#park'></use>
          </svg>
          <h5> 4 Cities</h5>
        </div>
        <div class='boxes '>
          <svg>
            <use href='#badmintonico'></use>
          </svg>
          <h5> 31 + Courts </h5>
        </div>
      </div>
    </div>
  </>
);
const badmintonVenueList = [
  {
    companyName: "PlayAll",
    venueName: "PlayAll MGR Mogappair East",
    numberOfCourts: 6,
    // courtType: "6-Vs-6", 
    city: "Chennai",
    address: "Veeramamunivar St, Block 12, Block 11, J J Nagar, Anna Nagar, Chennai, Tamil Nadu - 600037 | Contact - 044-40114443",
    googleMapLink: "https://maps.app.goo.gl/hWTDbGtjTnEi5YNg6",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1748864752418-filename0.jpg"
       ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Arena MCL Hari Nagar",
    numberOfCourts: 2,
    city: "Delhi",
    address: "Olympus Sports Club Plot-96, Gram Shahdara, near Chauhan Market, Sector 141, Noida, Uttar Pradesh 201305| Contact - 011-411-70771",
    googleMapLink: "https://maps.app.goo.gl/bTNYvDwemSUN6xDg9",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1743157513555-filename2.jpg",
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1743157561304-filename0.jpg"
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll HICAS Coimbatore",
    numberOfCourts: 6,
    city: "Coimbatore",
    address: " Hindustan College of Arts & Science, Avinashi Rd, behind Nava India, Udayampalayam, Coimbatore, Tamil Nadu 641028 | Contact - 044-40114355",
    googleMapLink: "https://maps.app.goo.gl/W66hgWjS37q92m9p8",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1740379052747-filename0.jpg",
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1740379097975-filename1.jpg"
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Noida 141",
    numberOfCourts: 6,
    city: "Noida",
    address: "Olympus Sports Club Plot-96, Gram Shahdara, near Chauhan Market, Sector 141, Noida, Uttar Pradesh 201305| Contact - 011-411-70771",
    googleMapLink: "https://maps.app.goo.gl/JEp2FY4xTLQ7tKGw5",
    images: [
      "https://playallvenueimages.s3.ap-south-1.amazonaws.com/allvenues/olympus+sports-+sector+114+noida/olmpus1.jpg",
      "https://playallvenueimages.s3.ap-south-1.amazonaws.com/allvenues/olympus+sports-+sector+114+noida/olmpus2.jpg",
      "https://playallvenueimages.s3.ap-south-1.amazonaws.com/allvenues/olympus+sports-+sector+114+noida/olmpus3.jpg"
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Gaurcity 1",
    numberOfCourts: 8,
    city: "Greater Noida",
    address: "Gaur City Sports Complex, E Block, Gaur City 1, Sector 4, Greater Noida, Uttar Pradesh 201009| Contact - 01141187822 | 01141170333",
    googleMapLink: "https://goo.gl/maps/XRjs1h6FZjYUoPtv7",
    images: [
      "images/gallery/gaurs_badminton_0.png",
      "images/gallery/gaurs_badminton_1.png",
      "images/gallery/gaurs_badminton_2.png"
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll MPS Noida 11",
    numberOfCourts: 4,
    city: "Noida",
    address: "S1 Modern School, R Block, Sector 11, Noida, Uttar Pradesh 201301| Contact - 01141169060",
    googleMapLink: "https://maps.app.goo.gl/pr2dVjxZVJq8fwiu8",
    images: [
      "images/gallery/modern_badminton_0.png",
      "images/gallery/modern_badminton_1.png",
      "images/gallery/modern_badminton_2.png"
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Gurgaon 62",
    numberOfCourts: 6,
    city: "Gurugram",
    address: "CRPF Road, Opposite Heritage School, Sector 62, Gurugram, 122005, Haryana | Contact - 01141179906 | 01141169010",
    googleMapLink: "https://goo.gl/maps/ehmfU6Qtyw82",
    images: [
      'images/gallery/gurgaon_badminton_0.png',
      'images/gallery/gurgaon_badminton_5.png',
      'images/gallery/gurgaon_badminton_3.png',
      'images/gallery/gurgaon_badminton_4.png',
      'images/gallery/gurgaon_badminton_2.png',
      'images/gallery/gurgaon_badminton_1.png',
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Faridabad 86",
    numberOfCourts: 7,
    city: "Faridabad",
    address: "Near Sai Mandir, Sector 86, Faridabad, Haryana 121002 | Contact - 01141187780",
    googleMapLink: "https://maps.app.goo.gl/NXWdbBZ4TipBSeUh9",
    images: [
      'images/gallery/faridabad_badminton_0.png',
      'images/gallery/faridabad_badminton_1.png',
      'images/gallery/faridabad_badminton_2.png',
      'images/gallery/faridabad_badminton_3.png',
      'images/gallery/faridabad_badminton_4.png',
    ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Noida 73",
    numberOfCourts: 4,
    city: "Noida",
    address: "Near Noida Pet Clinic, Sector 73, Noida, Uttar Pradesh 201301 | Contact - 01140849901 | 01141169001",
    googleMapLink: "https://goo.gl/maps/MHyikEmmcw22",
    images: [
      "images/gallery/noida_badminton_0.png",
      "images/gallery/noida_badminton_5.png",
      "images/gallery/noida_badminton_3.png",
      "images/gallery/noida_badminton_4.png",
      "images/gallery/noida_badminton_2.png",
      "images/gallery/noida_badminton_1.png",
    ]
  },
  {
    companyName: "PlayAll Badminton Arena",
    venueName: "PlayAll Faridabad 88",
    numberOfCourts: 4,
    city: "Faridabad",
    address: "opp. RPS City, Pataakhe Wali Gali, RPS City, Sector 88, Faridabad, Haryana 121002 | Contact - 011-411-70888",
    googleMapLink: "https://maps.app.goo.gl/bPGw3EufQKovXFw47",
    images: [
      "images/gallery/Faridabad_88_1.png",
      "images/gallery/Faridabad_88_2.png",
      "images/gallery/Faridabad_88_3.png",
    ]
  }
]
const mainSection = (
  <>
  <main>
     {badmintonVenueList.map((item, index) => {
            return (
              <section class='partnersec ' key={`effejkbjdfb${index}`}>
                <div class='container'>
                  <div class='innerbx pb-5'>
                    {index % 2 === 0 ?
                      <div class='contentarea '>
                        <Zoom>  <h4 >{item.companyName}</h4>
                          <h2 >{item.venueName}</h2>
                          <p>With {item.numberOfCourts} Indoor <b>Badminton Courts</b> (Synthetic Mats), PlayAll is one of the best <b>Badminton Academy</b> in {item.city}. With Amenities like Ample Parking, online booking, and LED lighting  we ensure that your Badminton experience is hassel free and awesome. </p>
    
                        </Zoom>
    
                        <span class='address'>
                          Address - {item.address}
                        </span>
                        <div class='btarea mb-3'>
    
    
                          <a href={item.googleMapLink} class='btwhite1'
                            target="_blank"
                            rel="noreferrer"
                          >
    
                            <svg width='34' height='41'>
                              <use href='#googleMap'></use>
                            </svg>
                            <Zoom >Directions</Zoom>
                          </a>
                        </div>
    
    
                        <div class='sportsavailble'>
                          <Zoom>Book via</Zoom>
                          <div class='divider'></div>
                          <a
                            href='https://play.google.com/store/apps/details?id=com.playallrn'
                            class='btorng'
                            style={{ background: "#000000" }}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" "}
                            <img alt='' src='images/playStore.png' style={{ height: "120px" }} />
                          </a>
    
    
                          <div class='divider'></div>
                          <a
                            class='btorng justify-content-center'
                            href='https://apps.apple.com/us/app/play-all/id6480510323'
                            style={{ background: "#000000" }}
                            rel="noreferrer"
                            target="_blank"
                          >
                            <img src='images/appStore.png' alt='' style={{ height: "120px" }} />
                          </a>
                        </div>
    
    
                      </div>
                      :
                      <div class=' rightbx startplayarea1 d-flex justify-content-center'>
                        <div class='startplaybox'>
                          <Fade >
                            <Carousel showThumbs={false} showIndicators={false} showStatus={false} autoPlay={true} infiniteLoop={true} interval={1400} swipeable={true} emulateTouch={true}>
                              {item.images.map((insideItem, index) => {
                                return (
                                  <img src={insideItem} alt='pickleball in jaipur' key={`ewfhewhklkwebkj${index}`} />
                                )
                              })}
    
                            </Carousel></Fade>
                        </div>
                      </div>
                    }
                    {index % 2 === 0 ?
                      <div class=' rightbx startplayarea1 d-flex justify-content-center'>
                        <div class='startplaybox'>
                          <Fade >
                            <Carousel showThumbs={false} showIndicators={false} showStatus={false} autoPlay={true} infiniteLoop={true} interval={1400} swipeable={true} emulateTouch={true}>
                              {item.images.map((insideItem, index) => {
                                return (
                                  <img src={insideItem} alt='pickleball in jaipur' key={`ewfhewhklkwebkj${index}`} />
                                )
                              })}
    
                            </Carousel></Fade>
                        </div>
                      </div>
                      :
                      <div class='contentarea '>
                        <Zoom>  <h4 >{item.companyName}</h4>
                          <h2 >{item.venueName}</h2>
                          <p>With {item.numberOfCourts} Indoor <b>Badminton Courts</b> (Synthetic Mats), PlayAll is one of the best <b>Badminton Academy</b> in {item.city}. With Amenities like Ample Parking, online booking, and LED lighting  we ensure that your Badminton experience is hassel free and awesome. </p>
    
                        </Zoom>
    
                        <span class='address'>
                          Address - {item.address}
                        </span>
                        <div class='btarea mb-3'>
    
    
                          <a href={item.googleMapLink} class='btwhite1'
                            target="_blank"
                            rel="noreferrer"
                          >
    
                            <svg width='34' height='41'>
                              <use href='#googleMap'></use>
                            </svg>
                            <Zoom >Directions</Zoom>
                          </a>
                        </div>
    
    
                        <div class='sportsavailble'>
                          <Zoom>Book via</Zoom>
                          <div class='divider'></div>
                          <a
                            href='https://play.google.com/store/apps/details?id=com.playallrn'
                            class='btorng'
                            style={{ background: "#000000" }}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" "}
                            <img alt='' src='images/playStore.png' style={{ height: "120px" }} />
                          </a>
    
    
                          <div class='divider'></div>
                          <a
                            class='btorng justify-content-center'
                            href='https://apps.apple.com/us/app/play-all/id6480510323'
                            style={{ background: "#000000" }}
                            rel="noreferrer"
                            target="_blank"
                          >
                            <img src='images/appStore.png' alt='' style={{ height: "120px" }} />
                          </a>
                        </div>
    
    
                      </div>
    
                    }
    
                  </div>
                </div>
              </section>
            )
          })}
  </main>
    
  </>
);

const Badminton = () => {
  return (
    <>
      <Helmet>
        <title>Badminton - Badminton court and Badminton academy near me</title>
        <meta name="description" content="Play all offers best Badminton court and badminton academy. In Noida we have a 4 court indoor badminton academy near sector 73. In Faridabad we have 7 indoor badminton court near sector 86. In Gurgoan we have a 6 court badminton academy near sector 62." />
      </Helmet>
      <div style={{ overflowY: "scroll", height: "calc(100vh)" }}>
        {topSectionData}
        <div class='headbanner startplayingbg' data-aos='fade'>
          <div class='container '>
            <NavSection current={"badminton"} />
            {contentSection}
          </div>
        </div>
        {mainSection}
        {footerSection}
      </div>
    </>
  );
};

export default Badminton;
